var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.76,
    height: 33.76,
    viewBox: "0 0 42.66 47.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M30.81,28.44A11.85,11.85,0,0,1,42.66,39.776V45.03a2.37,2.37,0,0,1-4.723.277l-.017-.277V40.29a7.11,7.11,0,0,0-6.693-7.1l-.417-.012H11.85a7.11,7.11,0,0,0-7.1,6.693l-.012.417v4.74a2.37,2.37,0,0,1-4.723.277L0,45.03V40.29A11.85,11.85,0,0,1,11.336,28.44H30.81ZM21.33,0A11.85,11.85,0,1,1,9.48,11.85,11.85,11.85,0,0,1,21.33,0Zm0,4.74a7.11,7.11,0,1,0,7.11,7.11A7.11,7.11,0,0,0,21.33,4.74Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cef06707dac9dc30d7d2dd062ae480c2.svg";
export { ForwardRef as ReactComponent };